export default "__VITE_ASSET__DJ9nd0ZN__"